import { Form, Select, Row, Col, Input } from 'antd';
import useCoreInfoMeterSourceInfoSection, { isSourceValueValidForFileSource } from './useCoreInfoMeterSourceInfoSection';

const SOURCE_VALUE_MISMATCH_MESSAGE =
  'The selected Source Delivered and Source Received values are not valid for the chosen Meter File Source. Please update them before saving.';

const CoreInfoMeterSourceInfoSection = ({ form }) => {
  const { kwhOptions } = useCoreInfoMeterSourceInfoSection(form);

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Meter File Source" name="meterFileSource" rules={[{ required: true, message: 'Meter File Source is required' }]}>
            <Select
              options={[
                { value: 'AMI', label: 'AMI' },
                { value: 'AMR', label: 'AMR' },
                { value: 'SCADA', label: 'SCADA' },
                { value: 'MMR', label: 'MMR' },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Meter Coefficient"
            name="multiplier"
            rules={[
              { required: true, message: 'Meter Coefficient is required.' },
              { pattern: /^\d+(?:\.\d+)?$/, message: 'Meter Coefficient must be a numeric value.' },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="KWH Generated"
            name="kwhGenerated"
            dependencies={['meterFileSource', 'kwhUsed']}
            rules={[
              { required: true, message: 'KWH Generated is required' },
              {
                validator(_, value) {
                  const kwh_used = form.getFieldValue('kwhUsed');
                  const fileSource = form.getFieldValue('meterFileSource');

                  if (!value) return Promise.resolve(); // Let required rule handle empty case

                  if (!isSourceValueValidForFileSource(value, fileSource)) {
                    return Promise.reject(new Error(SOURCE_VALUE_MISMATCH_MESSAGE));
                  }

                  if (value && kwh_used && value === kwh_used) {
                    return Promise.reject(
                      new Error('KWH Generated and Used cannot be the same.')
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Select options={kwhOptions} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="KWH Used"
            name="kwhUsed"
            dependencies={['meterFileSource', 'kwhGenerated']}
            rules={[
              { required: true, message: 'KWH Used is required' },
              {
                validator(_, value) {
                  const kwhGenerated = form.getFieldValue('kwhGenerated');
                  const fileSource = form.getFieldValue('meterFileSource');

                  if (!value) return Promise.resolve(); // required handles empty

                  if (!isSourceValueValidForFileSource(value, fileSource)) {
                    return Promise.reject(new Error(SOURCE_VALUE_MISMATCH_MESSAGE));
                  }

                  if (value && kwhGenerated && value === kwhGenerated) {
                    return Promise.reject(
                      new Error('KWH Used and Generated cannot be the same.')
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Select options={kwhOptions} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CoreInfoMeterSourceInfoSection;
